import { useQuery } from '@tanstack/react-query';
import { subscriptionService } from './subscription';

export const subscriptionKeys = {
  all: ['subscription'] as const,
  mine: ['subscription', 'me'] as const,
  entitlements: ['subscription', 'entitlements'] as const,
};

export function useSubscription() {
  return useQuery({
    queryKey: subscriptionKeys.mine,
    queryFn: subscriptionService.getMine,
    staleTime: 60_000,
  });
}

export function useEntitlements() {
  return useQuery({
    queryKey: subscriptionKeys.entitlements,
    queryFn: subscriptionService.getEntitlements,
    staleTime: 60_000,
  });
}

